import { render } from "./TemplatesView.vue?vue&type=template&id=d03b3680&scoped=true"
import script from "./TemplatesView.vue?vue&type=script&lang=js"
export * from "./TemplatesView.vue?vue&type=script&lang=js"

import "./TemplatesView.vue?vue&type=style&index=0&id=d03b3680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d03b3680"]])

export default __exports__